import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import { useTranslation } from '@/services';
import TokenName from '../token/TokenName';
const RemoveLiquidityLoad = (props: AddLiquidityData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {t('liquidity.remove')}&nbsp;
            <TokenName token={props.tokenA} /> {props.tokenANumber} {t('liquidity.upon')}
        </div>
    );
};

export default RemoveLiquidityLoad;
